exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".bordered-choices .ui-select-choices-row-inner {\n  border-bottom: 1px solid var(--color-seashell);\n}\ncopy-stage-card p {\n  margin: 0;\n}\n.copy-stage-modal .no-stages-message {\n  padding: .5rem 2rem;\n}\n.copy-stage-modal .well {\n  margin-bottom: 0;\n  padding: 10px;\n}\n.copy-stage-modal .well p {\n  margin: 0;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib!./node_modules/less-loader/dist/cjs.js!./app/scripts/modules/core/src/pipeline/config/copyStage/copyStage.modal.less
// module id = 2951
// module chunks = 0